/**
 * 아직 안 내보낸 기능을 가리는 스위치.
 *
 * 왜 주석이 아니라 상수인가
 * ------------------------
 * 덜 된 기능을 주석으로 막으면 실기기에서 볼 때마다 풀었다 막았다 하게 되고,
 * **한 번 깜빡하면 그대로 출시된다.** 상수로 두면 켜는 자리가 한 곳뿐이라
 * 깜빡할 자리가 없다.
 *
 * 꺼 두면 번들에 아예 안 남는다
 * ---------------------------
 * 상수 false 로 감싼 코드는 압축 단계에서 통째로 사라진다 — 화면도 문자열도
 * 안 남는다. 2026-10-15 에 `process.env.NODE_ENV === 'development'` 로 꺼 두고
 * 운영 번들에서 '/collect'·'먹은 사진 담아두기' 0건인 것을 확인했다.
 * 다음에 또 덜 된 기능을 가릴 때 같은 방법을 쓰면 된다.
 */

/**
 * 기록할 사진 담아두기.
 *
 * 2026-10-16 켰다. 쓰는 곳은 세 군데이고 전부 이 상수를 본다.
 *   routes.tsx       /collect, /collect/guide 길
 *   MainHome.tsx     홈 헤더의 들어가는 버튼
 *   Go.tsx           홈 화면 바로가기('이번 주 뭐 먹었어?')의 목적지
 *
 * 켤 때 순서 — **웹을 앱보다 먼저 내보낸다.** 앱(1.0.43)은 공유받은 사진을
 * 보관하고 /collect 로 보내는데, 그때 길이 없으면 빈 화면이 뜬다.
 */
export const COLLECT_READY = true

/**
 * 대학교 연결.
 *
 * 2026-11-01 홈 헤더에 버튼만 먼저 붙였다. 눌러서 가는 화면은 아직 기획 중이라
 * `/university` 는 자리만 잡아둔 상태다.
 *
 * **길은 열어두고, 보이는 사람만 제한한다.** 이 기능은 운영에 나가더라도
 * 아래 `UNIVERSITY_PREVIEW_USER_IDS` 에 있는 계정에만 버튼이 보인다.
 * 전체 공개할 때 할 일은 `canSeeUniversity` 가 `UNIVERSITY_READY` 만 보도록
 * 바꾸는 것 하나뿐이다.
 *
 * 주의 — **이건 잠금장치가 아니다.** 계정 번호는 번들을 열면 보이고,
 * 주소(`/university`)를 직접 치면 누구나 들어간다. 화면이 실제 데이터를
 * 다루기 시작하면 **서버에서도 같은 자격을 확인해야 한다.**
 */
export const UNIVERSITY_READY = true

/**
 * 2026-11-04 전체 공개(도연님). 그전까지는 17·455 두 계정에만 보였다.
 * 그룹 자격은 서버가 확인한다(UniversityController::group — 인증 안 했으면 403).
 */
export const canSeeUniversity = (userId: string | null | undefined): boolean =>
  UNIVERSITY_READY && !!userId

/**
 * ⚠ `public/images/` 아래 그림을 고칠 때
 *
 * nginx 가 이미지를 `Cache-Control: public, immutable, max-age=31536000` 으로
 * 내보낸다. **immutable 이면 브라우저가 서버에 물어보지도 않는다** — 같은
 * 파일명으로 덮어쓰면 이미 받아 간 기기에서는 1년 동안 옛 그림이 그대로 보인다.
 * 2026-11-02 에 학사모 아이콘이 이걸로 갤럭시 실기기에서 안 바뀌었다.
 *
 * **고칠 때는 파일명에 번호를 올리고(`-v2`, `-v3`) 쓰는 쪽도 같이 바꾼다.**
 * S3 카테고리 아이콘에 둔 규칙과 같은 이유다.
 */

/**
 * 친구 초대(추천인 코드). 2026-11-04 켰다(도연님).
 *
 * 켜지면: 가입에 추천인 코드 단계(건너뛰기 있음), 환경설정 '친구 초대',
 * /invite 화면, 대학교 인증 완료 → 친구 초대 → 대학교 그룹 흐름.
 * 끄면: 가입에 코드 단계가 없고, '친구 초대하기'는 앱 받는 링크만 공유한다.
 */
export const REFERRAL_READY = true
